export default __webpack_public_path__ + "static/media/appStore_es.5b06130e.png";